import React, { FC, useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import {
  CreateUserWalletRequestDto,
  UpdateUserWalletRequestDto,
  CurrenciesCrypto,
  ISfWallet,
} from '@sparling/financial-common'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { InputSelect } from '../../../../../../../components/Dashboard/InputSelect'
import { createEnum } from '../../../../../../../utils/createEnum'
import { InputField } from '../../../../../../../components/Dashboard/InputField'
import { Modal } from '../../../../../../../components/Dashboard/Modal'

interface Props {
  isOpen: boolean
  modalClose: () => void
  fields: ISfWallet
}

export const WalletsModal: FC<Props> = ({ isOpen, fields, modalClose }) => {
  const [formValues, setFormValues] = useState<ISfWallet>(fields || {})

  const formMethods = useForm<ISfWallet>({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: classValidatorResolver(fields ? UpdateUserWalletRequestDto : CreateUserWalletRequestDto),
  })

  const { getValues, setValue, reset } = formMethods

  useEffect(() => {
    if (!!fields && Object.keys(fields).length > 0) {
      setFormValues((prev) => {
        if (Object.keys(prev).length === 0) {
          return fields
        }

        return prev
      })
    }
  }, [fields])

  useEffect(() => {
    reset()
    Object.entries(formValues).forEach(([key, value]) => {
      setValue(key as keyof ISfWallet, value)
    })
  }, [formValues, getValues, reset, setValue])

  return (
    <Modal
      title={'Wallet Details'}
      isOpen={isOpen}
      modalClose={modalClose}
      onCancel={modalClose}
      cancelTitle={'Close'}
      width={680}
      submitButtonProps={{
        type: 'button',
      }}
    >
      <FormProvider {...formMethods}>
        <Grid container spacing={2.5}>
          <Grid item xs={12} sm={12} container direction="column">
            <InputSelect
              key="currency"
              labelName="Currency"
              inputName="currency"
              placeholder="Please Select"
              enums={createEnum(CurrenciesCrypto)}
              width={'100%'}
              mb={20}
              defaultValue={formValues?.currency}
              disable
            />
            <InputField
              key="address"
              labelName="Address"
              inputName="address"
              inputType="text"
              width={'100%'}
              marginBottom={20}
              defaultValue={formValues?.address}
              disabled
            />
            <InputField
              key="addressSuffix"
              labelName="Address Suffix"
              inputName="addressSuffix"
              inputType="text"
              width={'100%'}
              marginBottom={20}
              defaultValue={formValues?.addressSuffix}
              disabled
            />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
